;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .controller('EditProductTypeController', EditProductTypeController)

  EditProductTypeController.$inject = [
    // Angular
    '$uibModalInstance',
    // Managers
    // Services
    'FilterService'
    // Resolve

  ]

  function EditProductTypeController (
    // Angular
    $uibModalInstance,
    // Managers
    // Service
    FilterService
    // Resolve
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
      // Attributes
      // Methods
        cancel: cancel,
        ok: ok,
        searchTypes: searchTypes
      })
    }

    function searchTypes (search) {
      FilterService.searchTypes(search).then(function (types) {
        self.types = types
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function ok () {
      $uibModalInstance.close(self.productType)
    }
  }
})
(window.angular, window._)